import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseProblem } from '@/api/responses/problems'

export namespace ProblemsApi {
  /**
   * 小問情報取得
   *
   * @param problemId 小問ID
   * @returns 小問情報
   */
  export async function getProblem(problemId: number): Promise<ApiResponseProblem> {
    return await ApiBase.get(`/problems/${problemId}`)
  }

  /**
   * 小問正答情報取得
   *
   * @param problemId 小問ID
   * @returns 小問情報(正答情報あり)
   */
  export async function getProblemCorrect(problemId: number): Promise<ApiResponseProblem> {
    return await ApiBase.get(`/problems/${problemId}/correct`)
  }
}
